import type { IApiClientResponse } from "../AxiosApiClientInstance/dtos/AxiosApiClientResponse";
import type { IApiClientRequestConfigOptions } from "./ApiClientRequestConfigOptions.interface";
import type { IApiClientService } from "./ApiClientService.interface";

export abstract class ApiClientAbstract {
  constructor(private _client: IApiClientService) {}
  protected get<Data>(url: string, config?: IApiClientRequestConfigOptions): Promise<IApiClientResponse<Data>> {
    return this._client.get(url, config);
  }

  protected post<Data, ResponseData>(
    url: string,
    body: Data,
    config?: IApiClientRequestConfigOptions
  ): Promise<IApiClientResponse<ResponseData>> {
    return this._client.post(url, body, config);
  }

  protected patch<Data, ResponseData>(
    url: string,
    body: Data,
    config?: IApiClientRequestConfigOptions
  ): Promise<IApiClientResponse<ResponseData>> {
    return this._client.patch(url, body, config);
  }

  protected _genericException() {
    return new Error(`Failed to fetch data with ${this.constructor.name}`);
  }
}
